/**
 * GoogleDriveLogo
 * ────────────────
 * Single source of truth for the Google Drive logo across the app.
 * Renders the customer-provided PNG via an <img> tag so it can be swapped
 * by editing this file alone, instead of hunting down inline SVGs.
 *
 * Usage:
 *   <GoogleDriveLogo />                 // 16×16 by default
 *   <GoogleDriveLogo className="w-6 h-6" />
 *
 * The new mark is a triangular tri-color glyph (blue / green / yellow)
 * with a white center, hosted on the Emergent assets CDN.
 */
import React from "react";

const GDRIVE_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_638059b9-0a67-4418-a27c-c4601db7be98/artifacts/pkqdmm92_1000602403.jpg";

export default function GoogleDriveLogo({ className = "w-4 h-4", alt = "Google Drive" }) {
  return (
    <img
      src={GDRIVE_LOGO_URL}
      alt={alt}
      loading="lazy"
      decoding="async"
      // `object-contain` so the JPG (which has a white background) renders
      // correctly inside any aspect ratio the caller picks via Tailwind.
      // `scale-150` makes the actual glyph 1.5× bigger inside whatever
      // box the parent provides — perfect for badges where the white
      // background of the JPG visually merges with the white container.
      className={`${className} object-contain inline-block scale-150`}
      draggable={false}
    />
  );
}
